import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {ActionBarButtonComponent} from './action-bar-button.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        ActionBarButtonComponent
    ],
    exports: [
        ActionBarButtonComponent
    ],
})
export class ActionBarButtonModule {
}
